import type {FC} from 'react';
import {MdOutlineTipsAndUpdates} from 'react-icons/md';

// TODO: Tipsの中身を詰める

export const GenerateTips: FC = () => {
  const tips = [
    {
      title: '具体例を交えて記述する',
      description:
        '記入する際は、具体的な内容を盛り込み、イメージしやすいように記述しましょう。',
      examples: [
        'NG例: 「アプリを開発しました。」',
        'OK例1: 「タスクの自動整理が可能なTODOアプリを開発しました。期限順に並び替える機能を追加し、ユーザー満足度が80%以上に向上しました。」',
        'OK例2:',
        '- 参加者管理ツールを開発',
        '- イベント参加者を一覧表示し、登録・削除が可能 ',
        '- カレンダー連携機能 ',
      ],
    },
    {
      title: '数字や成果を含める',
      description:
        '「どのくらい効果があったのか」を簡単な数字や具体的な成果で示しましょう。',
      examples: [
        '例：',
        ' - 「クエリ速度を30%向上」',
        ' - 「50人の学生が利用し、満足度85%に向上」',
        ' - 「新機能追加後、売上15%増加」',
      ],
    },
    {
      title: '箇条書きでもOK',
      description:
        '完璧な文章でなくても、箇条書きや簡潔なキーワードで十分です。文体も気にする必要はありません。',
      examples: [
        '例:',
        '- 背景: チーム内で進捗管理が非効率だった。',
        '- 工夫点: タスク管理 リアルタイム更新機能を追加。',
        '- 成果: 会議時間を週1時間削減。',
      ],
    },
  ];

  return (
    <div className=" bg-white text-black-1 pc:shadow-card pc:p-16 pc:rounded-16 pc:w-[422px]">
      <div className="flex text-lg font-bold items-center gap-4 mb-16">
        <MdOutlineTipsAndUpdates size={24} />
        入力のヒント
      </div>
      {tips.map((tip) => (
        <Tip
          key={tip.title}
          title={tip.title}
          description={tip.description}
          examples={tip.examples}
        />
      ))}
    </div>
  );
};

const Tip: FC<{
  title: string;
  description: string;
  examples?: string[];
}> = ({title, description, examples}) => {
  return (
    <div className="flex flex-col gap-4 mb-16">
      <div className="text-md font-bold">{title}</div>
      <div className="text-base">{description}</div>
      {examples && (
        <div className="text-base p-16 bg-background-1 rounded-16">
          {examples.map((example) => (
            <p key={example}>{example}</p>
          ))}
        </div>
      )}
    </div>
  );
};
